module.exports = __webpack_public_path__ + "img/article_home.3b14ca74.svg";